import { render, staticRenderFns } from "./Droogdokkenpark.vue?vue&type=template&id=1522199b&"
import script from "./Droogdokkenpark.vue?vue&type=script&lang=ts&"
export * from "./Droogdokkenpark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports